import clsx from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { ButtonProps } from '../button/button';
import { Button } from '../button/button';
import {
  tooltipDescription,
  tooltipTextContent,
  tooltipTitle,
} from './tooltip.css';

export const TooltipTitle = ({
  className,
  ...props
}: ComponentPropsWithRef<'div'>) => (
  <div {...props} className={clsx(tooltipTitle, className)} />
);
export const TooltipDescription = ({
  className,
  ...props
}: ComponentPropsWithRef<'div'>) => (
  <div {...props} className={clsx(tooltipDescription, className)} />
);
export const TooltipTextContent = ({
  className,
  ...props
}: ComponentPropsWithRef<'div'>) => (
  <div {...props} className={clsx(tooltipTextContent, className)} />
);
export const TooltipPrimaryAction = (props: ButtonProps) => {
  return <Button variant="outline" size="small" {...props} />;
};
